import { IMemberContact } from './memberContact';
import { IMemberEmergencyContact } from './memberEmergencyContact';
import { IMemberFreezeDetail } from './memberFreezeDetail';
import { IMemberFeeDetails } from './feeDetail';
import { IAttendance } from './attendance';
import { ISettings } from './settings';
import { Customerstrainer } from './Customerstrainer';
import { IMemberPaymentOnRegistration } from './paymentOnRegistration';

export class IMember {
    _id: string;
    name: string;
    dateOfBirth: Date;
    email: string;
    gender: string;
    password: string;
    profile: string;
    tagNumber: string;
    oldSystemId: string;
    noteDetails: string;
    description: string;
    joiningDate: Date;
    registerationFee: string;
    trainingFee: string;
    monthFee: string;
    feeDetails: IMemberFeeDetails[];
    paymentOnRegistration: IMemberPaymentOnRegistration;
    attendance: IAttendance[];
    contactDetail: IMemberContact;
    freezeDetail: IMemberFreezeDetail;
    emergencyContact: IMemberEmergencyContact;
    customerstrainer: Customerstrainer;
    relatedMember: IRelatedMember[];
    profession: string;
    question1: string;
    question2: string;
    question3: string;
    gPTQuestion: string;
    settings: ISettings;
    branch: string;
    company: string;
    isDelete: boolean;
    biometricData: string;
    isBiometricVerified: boolean;
    packageType: string;
    packageName: string
    packageId: string;
    cardNo: string;
    customerPackageFee: number;
    packageLogo: string;
    selectedPaid: boolean = false;
    isSynced = false;
    isLocked = false;
    isDefaulter: boolean;
    // covidImageUrl: string;
    CNIC: string;
    CNICImageUrl: string;
    oldDate: Date;
    currentUserData: any;
    type: any;
    scope: any;
    oldValue: any;
    memberSettingFlag: boolean;
    initiatedFrom: any;
    createdBy: string;
    enquiryId: string;
    acknowledgedImage: string;
}

class IRelatedMember {
    name: string;
    memberId: string;
    phone: string;
    packageId: string;
    tagNumber: string;
}